import React, { useState, useEffect, useReducer } from "react";
import { Alert, Button, Card, Table } from "react-bootstrap";

const PollSubmissionQuestionOptions = ({ question, loadData }) => {


  return (
    <>
      <div className="mt-2">
        {(question.options.length > 0) ? <>
          {question.options.map((option, index) => {
            return <div className="optionContainer mb-2">
              <span className="VotersCount" style={option.optionValue === "1" ? {
                backgroundColor: '#169d57',
                padding: '5px 5px',
                marginRight: 10,
                borderTopRightRadius: 10,
                borderEndStartRadius: 10,
                marginBottom: 5,
                color: '#fff'
              } : {
                backgroundColor: '#999',
                padding: '5px 5px',
                marginRight: 10,
                borderTopRightRadius: 10,
                borderEndStartRadius: 10,
                marginBottom: 5,
                color: '#fff'

              }}>{option.optionValue === "1" ? <span>&#10003;</span> : <span >&#10007;</span>}</span>

              <span className="optionTitle ml-0">
                {option.option}
              </span>
            </div>
          })}
        </> : <>
          <Alert variant="warning" className="m-0">
            No options.
          </Alert>
        </>}
      </div>
    </>
  );
};

export default PollSubmissionQuestionOptions;
